module.exports = __webpack_public_path__ + "static/media/galerija_2021 (20).5b6e5cd9.jpg";